import { Link } from 'react-router-dom'
import Contact from '@/components/Contact'
import SiteFooter from '@/components/SiteFooter'
import SiteHeader from '@/components/SiteHeader'
import Seo from '@/components/Seo'
import { OwlWithLetterMark } from '@/components/public/motifs'
import PublicBirds from '@/components/public/PublicBirds'
import { Button } from '@/components/ui/button'
import { getStudioHref } from '@/lib/hostRouting'
import { prefetchBookPage } from '@/lib/prefetchBook'

export default function ContactPage() {
  const studioAccessHref = getStudioHref('/login#request-access')

  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <Seo path="/contact" />
      <SiteHeader />

      <main className="flex-1">
        <div className="relative">
          <PublicBirds className="hidden sm:block" />
          <section className="relative mx-auto w-full max-w-4xl px-5 pb-10 pt-12 sm:pt-16">
          <div className="grid gap-8 sm:grid-cols-[1fr_auto] sm:items-center">
            <div>
              <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">Contact</h1>
              <p className="mt-4 max-w-2xl text-sm leading-7 text-muted-foreground">
                Most plans work out of the box on Retira.app, but every plan is different. If you&apos;ve got a case it
                doesn&apos;t handle, a feature you wish it had, or a scenario you want to talk through, email{' '}
                <a
                  href="mailto:hello@retira.app"
                  className="font-medium text-foreground underline underline-offset-4 hover:text-foreground/80"
                >
                  hello@retira.app
                </a>
                . A real person reads every message, and we can usually do more than you&apos;d expect.
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <Button asChild>
                  <Link to="/book" onPointerEnter={prefetchBookPage} onFocus={prefetchBookPage}>
                    Book a call
                  </Link>
                </Button>
                <span className="text-sm text-muted-foreground">
                  Prefer to talk it through? Grab 30 minutes with the founders.
                </span>
              </div>
            </div>
            <OwlWithLetterMark className="hidden h-36 w-36 shrink-0 sm:block" />
          </div>
          </section>
        </div>

        <section className="border-t border-border bg-card">
          <div className="mx-auto w-full max-w-4xl px-5 py-10 sm:py-12">
            <Contact />

            <div className="mt-8 border border-border bg-background p-5">
              <h2 className="text-base font-semibold">Want your own account?</h2>
              <p className="mt-1 text-sm leading-7 text-muted-foreground">
                Request access and we&apos;ll review it by hand. Already approved? The same page lets you log in.
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                <Button asChild>
                  <a href={studioAccessHref}>Request access or log in</a>
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  )
}
